(() => {
  const instances=new Map();
  function initialize(scope = document) {
    scope.querySelectorAll('[data-product-section]:not([data-ready])').forEach(section => {
      section.dataset.ready = 'true';
      const form = section.querySelector('[data-purchase-form]');
      if (!form) return;
      const data = JSON.parse(section.querySelector('[data-product-data]').textContent);
      const controller=new AbortController();
      const money = cents => new Intl.NumberFormat(data.lang, {style:'currency', currency:data.currency}).format(cents / 100);
      const saveLabel = percent => data.savePercent.replace('__PERCENT__', percent);
      const oncePrice = (variant, amount) => variant.oncePrices?.[amount] ?? variant.price * amount;
      function showSaving(element, percent) {
        if (!element) return;
        element.hidden = !(percent > 0);
        element.textContent = percent > 0 ? saveLabel(percent) : '';
      }
      const add = form.querySelector('[data-primary-add]');
      const sticky = section.querySelector('[data-sticky-buy]');
      const stickyAdd = section.querySelector('[data-sticky-add]');
      const params=new URLSearchParams(location.search);
      const initialVariant=data.variants.find(v=>String(v.id)===form.elements.id.value);
      const eligiblePlans=variant=>variant.plans.filter(p=>[1,2,3].includes(p.quantity));
      const requestedPlan=eligiblePlans(initialVariant).find(p=>String(p.id)===params.get('selling_plan'));
      let frequency=requestedPlan?.frequency || params.get('frequency') || '30-day';
      let activeChoice='';
      const quantity=params.get('quantity') || String(requestedPlan?.quantity || 1);
      if(['1','2','3'].includes(quantity))form.querySelector(`[name=quantity][value="${quantity}"]`).checked=true;
      if((params.get('purchase')==='subscription' || requestedPlan) && form.elements.purchase_mode)form.querySelector('[name=purchase_mode][value=subscription]')?.click();
      function update() {
        const variant = data.variants.find(v => String(v.id) === form.elements.id.value);
        if (!variant) return;
        const quantity = Number(form.elements.quantity.value || 1);
        const planSelect = form.elements.selling_plan;
        const plans=eligiblePlans(variant);
        const choices=plans.filter(p=>p.quantity===quantity).sort((a,b)=>parseInt(a.frequency)-parseInt(b.frequency));
        const choiceKey=`${variant.id}:${quantity}`;
        if(planSelect && choiceKey!==activeChoice) {
          planSelect.replaceChildren(...choices.map(p=>new Option(p.name,String(p.id))));
          const matching=choices.find(p=>p.frequency===frequency) || choices[0];
          if(matching)planSelect.value=String(matching.id);
          activeChoice=choiceKey;
        }
        const plan=choices.find(p=>String(p.id)===planSelect?.value);
        if(plan)frequency=plan.frequency;
        const subscriptionInput=form.querySelector('[name=purchase_mode][value=subscription]');
        if(subscriptionInput)subscriptionInput.disabled=!plan;
        const purchaseArea=form.querySelector('.f-product__purchase');
        if(purchaseArea)purchaseArea.hidden=!plan;
        if(!plan && subscriptionInput?.checked)form.querySelector('[name=purchase_mode][value=once]').checked=true;
        const subscribed=form.elements.purchase_mode?.value==='subscription';
        if (planSelect) planSelect.disabled = !subscribed;
        const area = form.querySelector('[data-plan-area]');
        if (area) area.hidden = !subscribed;
        const total = subscribed ? plan.price * quantity : oncePrice(variant, quantity);
        const reference = variant.price * quantity;
        const percent = Math.round((reference - total) * 100 / reference);
        section.querySelectorAll('[data-product-price]').forEach(el=>el.textContent=money(total));
        const compare = section.querySelector('[data-product-compare]');
        if (compare) { compare.hidden = total >= reference; compare.textContent = money(reference); }
        showSaving(section.querySelector('[data-product-saving]'), percent);
        form.querySelectorAll('[data-quantity-price]').forEach(el => {
          const amount = Number(el.dataset.quantityPrice);
          const amountPlan=plans.find(p=>p.quantity===amount && p.frequency===frequency);
          const amountTotal = subscribed && amountPlan ? amountPlan.price * amount : oncePrice(variant, amount);
          const amountReference = variant.price * amount;
          const amountPercent = Math.round((amountReference - amountTotal) * 100 / amountReference);
          el.textContent = money(amountTotal);
          const old = form.querySelector(`[data-quantity-compare="${amount}"]`);
          if (old) { old.hidden = amountTotal >= amountReference; old.textContent = money(amountReference); }
          showSaving(form.querySelector(`[data-quantity-saving="${amount}"]`), amountPercent);
        });
        form.querySelectorAll('[data-best-value]').forEach(el => el.hidden = subscribed);
        form.querySelectorAll('.f-product__quantity--best').forEach(el => el.classList.toggle('is-subscription', subscribed));
        const offerNote = form.querySelector('[data-volume-note]');
        if (offerNote) offerNote.hidden = subscribed;
        form.querySelector('[data-once-price]').textContent=money(oncePrice(variant, quantity));
        const subscriptionPrice=form.querySelector('[data-subscription-price]');
        const subscriptionUnit = plan?.price ?? variant.price;
        if(subscriptionPrice) subscriptionPrice.textContent=money(subscriptionUnit * quantity);
        showSaving(form.querySelector('[data-subscription-saving]'), Math.round((oncePrice(variant,quantity)-subscriptionUnit*quantity)*100/oncePrice(variant,quantity)));
        add.disabled=form.dataset.busy==='true' || !variant.available || (subscribed && !plan);
        if(form.dataset.busy!=='true')add.textContent=variant.available ? `${data.add} — ${money(total)}` : data.soldOut;
        if(stickyAdd){stickyAdd.disabled=add.disabled;stickyAdd.textContent=variant.available?data.add:data.soldOut;}
        section.querySelectorAll('[data-flavor-link]').forEach(link=>{
          const url=new URL(link.href);url.searchParams.set('quantity',quantity);url.searchParams.set('purchase',subscribed?'subscription':'once');
          url.searchParams.delete('plan_name');url.searchParams.delete('selling_plan');
          if(subscribed&&plan)url.searchParams.set('frequency',frequency);else url.searchParams.delete('frequency');link.href=url.href;
        });
      }
      form.addEventListener('change',update,{signal:controller.signal});update();
      let observer;
      if(sticky){
        let primaryPassed=false,footerVisible=false;
        const visibility=()=>sticky.hidden=!primaryPassed||footerVisible||!!document.querySelector('dialog[open],input:focus,textarea:focus,select:focus');
        observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.target===add)primaryPassed=!entry.isIntersecting&&entry.boundingClientRect.bottom<0;else footerVisible=entry.isIntersecting;});visibility();},{threshold:0});
        observer.observe(add);const footer=document.querySelector('footer');if(footer)observer.observe(footer);
        document.addEventListener('focusin',visibility,{signal:controller.signal});document.addEventListener('focusout',()=>requestAnimationFrame(visibility),{signal:controller.signal});
      }
      instances.set(section,()=>{controller.abort();observer?.disconnect();delete section.dataset.ready;});
    });
  }
  initialize();document.addEventListener('shopify:section:load',event=>initialize(event.target));
  document.addEventListener('shopify:section:unload',event=>{for(const [section,dispose]of instances)if(event.target.contains(section)){dispose();instances.delete(section);}});
})();



